import React from 'react';
import { GetServerSideProps, NextPage } from 'next';
import Layout from '../../../../components/layout';
import AdminLayout from '../../../../components/admin-layout';
import { useRouter } from 'next/router';
import AdminUserEditor from '../../../../components/@admin-user/admin-user-editor';
import usePermissionInRequest from '../../../../hooks/use-permission-in-request';
import useIsGuest from '../../../../hooks/use-is-guest';

const AdminUserEditPage: NextPage = () => {
  const router = useRouter();

  if (typeof window === 'undefined') {
    return null;
  }

  const { id } = router.query;

  return (
    <Layout title="User Administration">
      <AdminLayout
        title="Manage User"
        breadcrumb={{ url: '/admin/users/search', text: 'Back to Users' }}
      >
        <AdminUserEditor id={id as string} />
      </AdminLayout>
    </Layout>
  );
};

/* eslint-disable react-hooks/rules-of-hooks */
export const getServerSideProps: GetServerSideProps = async ({ req }) => {
  const isGuest = await useIsGuest(req);
  const isAuthorized =
    (await usePermissionInRequest(req, 'system_admin')) ||
    (await usePermissionInRequest(req, 'internal_access'));
  /* eslint-enable react-hooks/rules-of-hooks */

  if (isGuest) {
    return {
      notFound: true,
    };
  }

  if (!isAuthorized) {
    return {
      redirect: {
        destination: '/admin',
        permanent: false,
      },
    };
  }

  return {
    props: {},
  };
};

export default AdminUserEditPage;
